(() => {
  const initModernMobileMenu = () => {
    const drawer = document.querySelector("#m-menu-drawer.m-menu-drawer--modern");
    const closeButton = drawer?.querySelector("[data-modern-menu-close]");
    const hamburger = document.querySelector(".m-hamburger-box");
    const trigger = hamburger?.closest(".m-menu-button__trigger");

    if (!drawer || !closeButton || !hamburger || drawer.dataset.modernMenuReady) return;

    drawer.dataset.modernMenuReady = "true";
    let lastFocusedElement = null;

    const syncState = () => {
      const isOpen = drawer.classList.contains("open");
      drawer.setAttribute("aria-hidden", String(!isOpen));
      hamburger.setAttribute("aria-expanded", String(isOpen));
      trigger?.setAttribute("aria-expanded", String(isOpen));
      document.documentElement.classList.toggle("tanatel-mobile-menu-open", isOpen);

      if (isOpen) {
        lastFocusedElement = lastFocusedElement || document.activeElement;
        window.requestAnimationFrame(() => closeButton.focus({ preventScroll: true }));
      } else if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus({ preventScroll: true });
        lastFocusedElement = null;
      }
    };

    const syncSubmenuStates = () => {
      drawer.querySelectorAll(".m-menu-mobile__toggle-button").forEach((button) => {
        const submenu = button.parentElement?.querySelector(":scope > .m-megamenu-mobile");
        button.setAttribute("aria-expanded", String(Boolean(submenu?.classList.contains("open"))));
      });
    };

    // The theme's menu controller listens on the small icon itself. Forward a
    // tap from the rest of the accessible 42px trigger to that same controller.
    trigger?.addEventListener("click", (event) => {
      if (!event.target.closest(".m-hamburger-box")) hamburger.click();
    });

    closeButton.addEventListener("click", () => {
      if (drawer.classList.contains("open")) hamburger.click();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drawer.classList.contains("open")) {
        event.preventDefault();
        hamburger.click();
      }
    });

    new MutationObserver(syncState).observe(drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });

    new MutationObserver(syncSubmenuStates).observe(drawer, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    syncState();
    syncSubmenuStates();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initModernMobileMenu, { once: true });
  } else {
    initModernMobileMenu();
  }
})();
